/** One collapsible section of the Goal Game control page. iPad-first: the
 *  whole header is the tap target and sections stack, so nothing scrolls
 *  sideways at 1024. */
import { ChevronDown } from 'lucide-react';

export const Block = ({ id, title, hint, open, onToggle, children, right }) => (
    <section className="rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden"
             data-testid={`gg-block-${id}`}>
        <button
            type="button"
            onClick={onToggle}
            data-testid={`gg-block-${id}-toggle`}
            className="w-full flex items-center gap-3 px-5 py-4 text-left hover:bg-slate-50 dark:hover:bg-slate-800/60"
        >
            <ChevronDown
                size={18}
                className={`shrink-0 transition-transform ${open ? '' : '-rotate-90'} text-slate-400`}
            />
            <span className="flex-1 min-w-0">
                <span className="block font-semibold text-slate-900 dark:text-slate-100">{title}</span>
                {hint && <span className="block text-xs text-slate-500 mt-0.5">{hint}</span>}
            </span>
            {right}
        </button>
        {open && (
            <div className="px-5 pb-5 pt-1 border-t border-slate-100 dark:border-slate-800"
                 data-testid={`gg-block-${id}-body`}>
                {children}
            </div>
        )}
    </section>
);

export default Block;
